define('core/models/Media',[
    'underscore',
    'backbone',

    'core/api',
    'core/UniqueModel',
], function (
    _,
    Backbone,

    api,
    UniqueModel
) {
    'use strict';

    var Media = Backbone.Model.extend({
        idAttribute: 'url',

        defaults: {
            // The server returns these ids, but they are not currently used
            // forum: -1,
            // id: -1,
            // post: -1,
            // thread: -1,

            mediaType: null,

            // HTML
            html: '',
            htmlWidth: null,
            htmlHeight: null,

            // Thumbnail
            thumbnailUrl: '',
            thumbnailWidth: null,
            thumbnailHeight: null,

            url: '',
            urlRedirect: '',
            resolvedUrl: '',
            resolvedUrlRedirect: '',

            // Text fields
            title: '',
            description: '',
            providerName: '',
        },

        parse: function (response) {
            return response.response;
        },

        sync: function (method, _model, options) {
            if (method !== 'read')
                throw new Error('Media models do not support methods other than "read".');

            return api.call('media/details.json', _.extend({
                method: 'POST',
                data: {
                    url: this.get('url'),
                    forum: options.forum,
                },
            }, options));
        },
    }, {
        MEDIA_TYPES: {
            IMAGE: '1',
            IMAGE_UPLOAD: '2',
            YOUTUBE_VIDEO: '3',
            WEBPAGE: '4',
            TWITTER_STATUS: '5',
            FACEBOOK_PAGE: '6',
            FACEBOOK_POST: '7',
            FACEBOOK_PHOTO: '8',
            FACEBOOK_VIDEO: '9',
            SOUNDCLOUD_SOUND: '10',
            GOOGLE_MAP: '11',
            VIMEO_VIDEO: '12',
            // ... GIST ...
            VINE_VIDEO: '14',
            GIF_VIDEO: '15',
        },
        WEBPAGE_TYPES: [
            '4',
            '6',
            '7',
        ],
    });

    UniqueModel.addType('Media', Media);

    return Media;
});

